import {
  IForgotPasswordRequestDto,
  postForgotPassword,
} from '@/shared/api/auth';
import { useAppMutation } from '@/shared/lib/useAppMutation';

type TForgotPasswordResponse = Awaited<ReturnType<typeof postForgotPassword>>;

export const useForgotPassword = () => {
  const forgotPasswordMutation = useAppMutation({
    mutationFn: (vars: IForgotPasswordRequestDto) => postForgotPassword(vars),
  });

  const forgotPassword = async (
    data: IForgotPasswordRequestDto,
    onSuccess?: (data: IForgotPasswordRequestDto) => void
  ): Promise<TForgotPasswordResponse> => {
    return forgotPasswordMutation.mutateAsync(data, {
      onSuccess: (_data, variables) => {
        onSuccess?.(variables);
      },
    });
  };

  return {
    forgotPassword,
    isPending: forgotPasswordMutation.isPending,
    isError: forgotPasswordMutation.isError,
    error: forgotPasswordMutation.error,
  };
};
